// Файл: src/components/NotificationBell.js
import React, { useState } from 'react';
import { IconButton, Badge } from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useNotifications } from '../context/NotificationContext';
import { NotificationPopover } from './NotificationPopover';

export const NotificationBell = () => {
  const { notifications, unreadCount, markAllAsRead, clearAll, setEventDetailsToShow } = useNotifications();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const open = Boolean(anchorEl);

  const handleNotificationClick = (notification) => {
    // Когда кликнули на уведомление:
    handleClose(); // 1. Закрываем Popover
    setEventDetailsToShow(notification.event); // 2. Говорим контексту, какое событие показать
  };

  return (
    <>
      <IconButton color="inherit" onClick={handleClick}>
        <Badge badgeContent={unreadCount} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <NotificationPopover
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        notifications={notifications}
        onMarkAllAsRead={markAllAsRead}
        onClearAll={clearAll}
        onNotificationClick={handleNotificationClick}
      />
    </>
  );
};